import React, {useEffect, useRef, useState} from 'react';
import './hero.styles.scss';
import mainBackground from '../../assets/images/background.png';
import playIndex from '../../assets/images/play.png';
import pauseIndex from '../../assets/images/pause.png';
import { globalHistory } from '@reach/router'

const Hero = () => {
    const translateRef = useRef();
    const heroRef = useRef();
    const [speed, setSpeed] = useState(0.2)
    const url = "https://duf4rsrp3ahzy.cloudfront.net/ALBUMS+COLLABS/demo-v2.mp3";

    const [icon, setIcon] = useState(playIndex);
    const [audio, setAudioState] = useState({});   
    
    useEffect(() => {
        setAudioState(new Audio(url))
        
    }, [])

    useEffect(() => {
        return globalHistory.listen(({ action }) => {
          if (action === 'PUSH') {
            setIcon(playIndex);
            audio.pause();
          } 
        })
      }, [audio])

    const handlePlay = () => {
        if (icon === playIndex) {
          setIcon(pauseIndex);
          
          audio.play();
        } else if (icon === pauseIndex) {
          setIcon(playIndex);
          audio.pause();
        }
       
      };

    const handleScroll = () => {
        let scroll = window.pageYOffset;
            const opacity = (scroll / 750).toFixed(1)
            const speed = translateRef.current.dataset.speed;
            setSpeed(speed)
            translateRef.current.style.transform = `translateY(${(scroll) * speed}px)`;
            heroRef.current.style.backgroundImage = `linear-gradient(rgba(0, 0, 0, ${opacity}), 
            rgba(0, 0, 0, ${opacity * 1.4})), url(${mainBackground})`
            translateRef.current.style.opacity = scroll === 0 ? 1 : 1 - opacity - 0.3
    }
    useEffect(() => {
        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    
    return (
        <main className="hero" ref={heroRef}>
            <div className="logo-image" ref={translateRef} data-speed={speed}>
                <div className="hero-title">
                    <h1>I SING <span className="highlight">&</span><br />I WRITE LYRICS</h1>

                </div>
                <div className="play">
                    <img onClick={handlePlay} alt="play"  src={icon}/>
                </div>
                
            </div>
        </main>
    )
}
    


export default Hero;